import type { AdminEvent } from "@/src/pages/Events/events.type";

/**
 * Le nombre de places occupées — participants validés, postulants exclus.
 *
 * ⚠️ **Un seul endroit pour ce calcul.** La liste l'affiche en « 4 / 8 » et la
 * fiche en compteur ; deux additions écrites séparément finiraient par ne plus
 * compter la même chose, et le remplissage est justement ce qu'on vient lire.
 */
export function filledPlaces(event: AdminEvent): number {
  return event.participants.length;
}

/** Ce qui reste à pourvoir, jamais négatif — un événement peut déborder. */
export function freePlaces(event: AdminEvent): number {
  return Math.max(0, event.places - filledPlaces(event));
}
